<template>
  <div class="download-page" :class="useIsMobile().value ? 'wap-div' : ''">
    <div class="page-container">
      <div class="content-card">
        <div class="left-section">
          <div class="mobile-logo-container">
            <div class="app-icon-box">
              <img src="http://image.kilimall.com/lite/new_wap/download-app/kili-logo.png" alt="Kilimall App" />
            </div>
          </div>

          <h1 class="main-title">Kilimall - Affordable & Safe Shopping</h1>
          <p class="description">
            Kilimall is Kenya's leading online shopping mall. It was launched in June 2014 with the mission of "Enriching Lives in Africa".
          </p>

          <div class="features-list">
            <div class="feature-item">
              <div class="icon-box">
                <img src="http://image.kilimall.com/lite/new_wap/download-app/huge-selction.png" alt="huge-selction" />
              </div>
              <span class="feature-text">Huge selection. Unbeatable prices</span>
            </div>
            <div class="border"/>
            <div class="feature-item">
              <div class="icon-box">
                <img src="http://image.kilimall.com/lite/new_wap/download-app/secure-payment.png" alt="secure-payment" />
              </div>
              <span class="feature-text">Secure payment options</span>
            </div>
            <div class="border"/>
            <div class="feature-item">
              <div class="icon-box">
                <img src="http://image.kilimall.com/lite/new_wap/download-app/fast-and-reliable-delivery.png" alt="fast-and-reliable-delivery" />
              </div>
              <span class="feature-text">Fast and reliable delivery</span>
            </div>
            <div class="feature-item">
              <div class="icon-box">
                <img src="http://image.kilimall.com/lite/new_wap/download-app/customer_service.png" alt="customer_service" />
              </div>
              <span class="feature-text">24/7 customer support</span>
            </div>
            <div class="border"/>
            <div class="feature-item">
              <div class="icon-box">
                <img src="http://image.kilimall.com/lite/new_wap/download-app/trustworthy.png" alt="trustworthy" />
              </div>
              <span class="feature-text">Trustworthy Reviews</span>
            </div>
          </div>
        </div>

        <!-- Right Section (Desktop) / Bottom (Mobile) -->
        <div class="right-section">
          <div class="desktop-header">
            <h2>Download the App Now</h2>
            <div class="app-icon-box-large">
               <img src="http://image.kilimall.com/lite/new_wap/download-app/kili-logo.png" alt="Kilimall App" />
            </div>
          </div>

          <div class="action-buttons">
            <button class="btn btn-android" @click="handleDownloadClick">
              <div class="btn-icon">
                <img src="http://image.kilimall.com/lite/new_wap/download-app/android.png" alt="android" />
              </div>
              <span>Download Android APK</span>
            </button>
            
            <a class="btn btn-google" href="https://play.google.com/store/apps/details?id=net.kilimall.shop" target="_blank">
              <div class="btn-icon">
                <img src="http://image.kilimall.com/lite/new_wap/download-app/google-store.png" alt="google-store" />
              </div>
              <span>Download on Google Play</span>
            </a>
            
            <a class="btn btn-apple" :href="regionId === '8' ? 'https://apps.apple.com/ug/app/kilimall/id6470137287' : 'https://apps.apple.com/ke/app/kilimall/id6470137287'" target="_blank">
              <div class="btn-icon">
                <img src="http://image.kilimall.com/lite/new_wap/download-app/apple.png" alt="apple" />
              </div>
              <span>Download on the App Store</span>
            </a>
          </div>

          <div class="footer">
            © {{ currentYear }} Kilimall. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { showToast } from 'vant'

definePageMeta({
  layout: false // Custom layout for this page
})

const regionId = useCurrentCountry().value ? useCurrentCountry().value.toString() : '6'
const currentYear = new Date().getFullYear()
const downloadUrl = ref<string>('')

if(process.client) {
  // Try to get download URL from store or fallback
  const globalData = useGlobalJsonData()
  if (globalData.value?.app_update?.data?.channelUrlMap?.h5) {
     downloadUrl.value = globalData.value.app_update.data.channelUrlMap.h5
  } else {
     // Default fallback or keep empty to let user know
     downloadUrl.value = 'https://m.kilimall.com/vue/download' // Just a fallback
  }
}

const handleDownloadClick = () => {
  if (!downloadUrl.value) {
    showToast('Download link is not available right now.')
    return
  }
  
  const ael = document.createElement('a')
  ael.href = downloadUrl.value
  ael.download = 'download'
  document.body.appendChild(ael)
  ael.click()
  document.body.removeChild(ael)

  showToast('Downloading, please wait.')
}
</script>

<style lang="scss" scoped>
.download-page {
  min-height: 100vh;
  background-color: #EFF1F3;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.page-container {
  width: 2400px;
  height: 1276px;
  border-radius: 40px;
  background: #FFF;
  box-shadow: 0 16px 56px -12px #18274b1f, 0 36px 176px -8px #18274b1a;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content-card {
  background-color: #fff;
  border-radius: 40px;
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.left-section, .right-section {
  flex: 1;
  padding: 160px 124px;
}

.left-section {
  border-right: 2px solid #f0f0f0;
}

.main-title {
  font-size: 48px;
  font-weight: 700;
  color: #111;
  margin-bottom: 20px;
  line-height: 1.3;
}

.description {
  font-size: 32px;
  color: #999999;
  line-height: 1.6;
  margin-bottom: 80px;
}

.features-list {
  display: flex;
  flex-direction: column;
}

.feature-item {
  display: flex;
  margin: 15px 0;
  align-items: center;
  padding: 15px;
  height: 96px;
  box-sizing: border-box;
  font-size: 32px;
  background-color: #F9FAFB;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateX(5px);
  }
}

.icon-box {
  width: 48px;
  height: 48px;
  img {
    width: 100%;
    height: 100%;
  }
}

.feature-text {
  margin-left: 36px;
  color: #333;
  font-weight: 400;
}

.right-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #F8F9FA;
}

.desktop-header {
  text-align: center;
  h2 {
    color: #150000;
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 60px;
  }
}

.app-icon-box-large {
  width: 192px;
  height: 192px;
  margin: 0 auto;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.mobile-logo-container {
  display: none;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  margin-top: 110px;
  width: 920px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 920px;
  height: 120px;
  border-radius: 100px;
  font-size: 36px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border: none;
  text-decoration: none;
  margin-bottom: 40px;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  }
  span {
    width: 500px;
    text-align: left;
  }
  .btn-icon {
    width: 40px;
    height: 40px;
    margin-right: 32px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.btn-android {
  background-color: #DD3131;
  color: #fff;
  
  .btn-icon {
    fill: #fff;
  }
}

.btn-google {
  background-color: #000;
  color: #fff;
  
  .btn-icon path:first-child { fill: #00E2F5; } 
  /* Note: The google play icon has specific colors, kept inline style in SVG but here overrides might happen if not careful. SVG has own fills. */
}

.btn-apple {
  background-color: #000;
  color: #fff;
}

.footer {
  font-size: 28px;
  color: #666666;
  text-align: center;
  font-weight: 400;
}

/* Mobile Responsive Styles */
@media (max-width: 960px) {
  .download-page {
    width: 100%;
    background-color: white;
    align-items: normal;
    .description {
      display: none;
    }
    .page-container {
      height: 100%;
      box-shadow: none;
    }
    .left-section {
      padding: 0;
      padding-top: 186px;
      .mobile-logo-container .app-icon-box {
        width: 160px;
        height: 160px;
      }
      .main-title {
        font-size: 28px;
      }
    }
    .feature-item {
      margin: 30px 0;
      .feature-text {
        font-size: 22px;
        padding: 0;
        margin: 0;
        color: #666666;
        margin-top: 10px;
      }
    }
    .border {
      border: 1px solid #CCCCCC;
      height: 30px;
      margin-top: 88px;
    }
    .right-section {
      margin-top: 120px;
      .action-buttons {
        margin-top: 0;
      }
      .footer {
        margin-top: 70px;
        font-size: 20px;
        font-weight: 400;
        position: fixed;
        width: 100%;
        text-align: center;
        bottom: 20px;
        left: 0px;
      }
    }
    .action-buttons {
      width: 100%;
      align-items: center;
      .btn  {
        width: 600px;
        height: 90px;
        font-size: 28px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 20px;
        span {
          width: 380px;
        }
      }
    }
    .content-card {
      flex-direction: column;
      box-shadow: none;
      margin-bottom: 0;
      background: transparent;
    }

    .left-section {
      border-right: none;
      text-align: center;
    }
    
    .right-section {
      padding: 20px 0 0 0;
      background: transparent;
    }
    
    .desktop-header {
      display: none; /* Hide the desktop "Download Now" and Logo */
    }
    
    .mobile-logo-container {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
      order: 1;
      width: 100%;
      
      .app-icon-box {
        width: 100px;
        height: 100px;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 20px;
        }
      }
    }

    .main-title {
      font-size: 24px;
      margin-bottom: 15px;
    }

    .description {
      font-size: 14px;
      margin-bottom: 30px;
      padding: 0 10px;
    }

    .features-list {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      
      .feature-item {
        background: transparent;
        flex-direction: column;
        text-align: center;
        padding: 10px;
        width: calc(33.33% - 10px);
        min-width: 100px;
        
        &:hover {
          transform: none;
        }
      }
    }
    
    .footer {
      margin-top: 40px;
      padding-bottom: 20px;
    }
  }
}

</style>
